<template>
   <section class="content-section">
       <a-step :step="isHPS(leadin) ? '3' : '4'" header="Zahlung" :leadin="leadin" />
          <a-form form class="info-form form" ref="paymentForm">

            <div class="container form__upper">
              <div class="container__inner content-wrap--summary">
                <div v-if="leadin.errorMessage.message" class="afterSendError">{{ leadin.errorMessage.message }}</div>
                <br v-if="leadin.errorMessage.message">
                  <h2 class="content-subheading content-subheading--lg">Ihre Auswahl</h2>
                  <div class="card card--bordered card--rounded card--light-blue card--small card--shadow-gray max--width">
                      <div class="card__header">
                          <strong class="card__title">{{ productName }}</strong>
                          <p class="card__subtitle">
                      <span>{{ productPrice | replacePoint }} €</span> monatlich
                    </p>
                      </div>
                      <div class="open-close__opener">
                        <span class="open-close__link">
                        <span class="show-more" v-if="!openClose" @click="openClose = true">Mehr Informationen <span class="icon-down-arrow"></span></span>
                        <span class="show-more less" v-if="openClose" @click="openClose = false">Weniger Informationen <span class="icon-down-arrow"></span></span>

                        </span>
                    </div>
                      <div class="card__body" v-html="productInfo" v-if="openClose"></div>
                  </div>
              </div>
              <div class="form__section crossselling" v-if="leadin.race == 1 && (leadin.hashR == undefined || leadin.hashR == false) && optimizely46 > 0">
                <div class="form__title form__title--protection-options has-tooltip-icon" v-if="leadin.risk_id == undefined && leadin.risk_id != '' && !isHPS(leadin)">
                  <h2>
                    Clever kombinieren & sparen
                  </h2>
                  <span class="icon icon-question-mark icon-circle icon--light-blue tooltip" @click="tooltips.combi = !tooltips.combi"></span>
                  <span class="tooltiptext" v-if="tooltips.combi">Wenn Sie den gewünschten Tarif mit einem zusätzlichen Haftpflichtschutz kombinieren, bekommen Sie einen Rabatt von 50% auf den Jahresbeitrag der Haftpflichtversicherung.</span>
                </div>
                <div class="protection-options" v-if="leadin.race == 1">
                  <ul class="protection-options__list"  v-if="leadin.risk_id == undefined && leadin.risk_id != '' && !isHPS(leadin)">
                    <li class="protection-options__item" v-for="(onecross, index) in cross" v-bind:key="index">
                      <Crossselling :registry="registry" v-model="leadin" :cross="onecross" ref="advanceCross" v-on:crosssellingCheck="crosssellingCheck($event)" />
                    </li>
                    <li class="protection-options__item" v-if="cross.length && optimizely46 === 2">
                      <Crossselling :registry="registry" v-model="leadin" :cross="{id: 5, cdiscount: 0, pdiscount: 0, combi: 5}" ref="advanceCross" v-on:crosssellingCheck="crosssellingCheck($event)" :isSale="false" />
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form__section form__section--payment">
                <div class="form__title">
                  <h2>Zahlungsintervall wählen</h2>
                </div>
                <div class="form__row short-radio">
                  <div v-bind:class="{'form__group': true, 'form--small25': true, 'hidden': cClass['cmonthly']}">
                    <div class="input-control">
                        <div class="wrapper short-radio">
                            <a-checkbox radio v-model="paymentinterval" label="monatlich" value="1" :size="16" v-on:check="pushDataLayer('zahlung', 'payment_intervall', 'monatlich')"/>
                        </div>
                    </div>
                  </div>
                  <div v-bind:class="{'form__group': true, 'form--small25': true, 'hidden': cClass['cyearly']}">
                    <div class="input-control">
                        <div class="wrapper">
                            <a-checkbox radio v-model="paymentinterval" label="jährlich" value="12" :size="16" v-on:check="pushDataLayer('zahlung', 'payment_intervall', 'jährlich')"/>
                        </div>
                    </div>
                  </div>
                  <div class="form__remark remark">
                    <span class="remark__icon">
                      <i class="icon-exclamation-point"></i>
                    </span>
                    <p class="remark__text">
                      Sie zahlen {{ interval }} {{ productPriceCalc }} €. Das gewählte Zahlungsintervall hat keine Auswirkungen auf Ihre Beitragssumme. Die erste Zahlung wird am {{ firstPaymentDate() }} fällig.
                    </p>
                  </div>
                </div>
              </div>
              <div class="form__section">
                <div class="form__title">
                  <h2>Zahlungsweise wählen</h2>
                </div>
                <div class="form__row">
                  <div class="tabs">
                    <div class="tabs__row">
                      <ul class="tabs__nav">
                        <li v-bind:class="{'active': isLs}" @click="setPaymentType('ls'); pushDataLayer('zahlung', 'payment_type', 'Lastschrift')">
                          <span>Lastschrift</span>
                        </li>
                        <li v-bind:class="{'active': !isLs}" @click="setPaymentType('ue'); pushDataLayer('zahlung', 'payment_type', 'Überweisung')"><span>Überweisung</span></li>
                      </ul>
                      <div class="tabs__content">
                        <div id="tab-1" v-bind:class="{'tabs__pane':true, 'active': isLs}">
                          <div class="form__row">
                            <div class="form__group form--huge-s">
                                <a-input required label="IBAN" v-model="iban" :rules="paymentRules" />
                            </div>
                          </div>
                          <div class="form__row checkbox narrow-text">
                                <a-checkbox v-model="sepa" required :eclass="leadin.errorMessage.sepa" label="Ich bestätige die Erteilung des
                                SEPA-Lastschrift-Rahmenmandats wie folgt" :size="16" :rules="sepaRule"/>
                          </div>
                          <div class="tabs__info">
                            <div class="jcf-scrollable">
                              <p class="tabs__text">
                                Ich ermächtige die AGILA Haustierversicherung
                                AG, Zahlungen von meinem Konto mittels
                                Lastschrift einzuziehen. Zugleich weise ich
                                mein Kreditinstitut an, die von AGILA
                                Haustierversicherung AG auf mein Konto
                                gezogenen Lastschriften einzulösen. Dieses
                                Rahmenmandat bezieht sich auf alle
                                gegenwärtigen und zukünftigen
                                Vertragsverhältnisse mit der AGILA
                                Haustierversicherung AG.
                              </p>

                              <p class="tabs__text">
                                Hinweis: Ich kann innerhalb von acht Wochen,
                                beginnend mit dem Belastungsdatum, die
                                Erstattung des belasteten Betrages verlangen.
                                Es gelten dabei die mit meinem Kreditinstitut
                                vereinbarten Bedingungen.
                              </p>

                              <p class="tabs__text">
                                Ich ermächtige die AGILA Haustierversicherung
                                AG, Zahlungen von meinem Konto mittels
                                Lastschrift einzuziehen. Zugleich weise ich
                                mein Kreditinstitut an, die von AGILA
                                Haustierversicherung AG auf mein Konto
                                gezogenen Lastschriften einzulösen. Dieses
                                Rahmenmandat bezieht sich auf alle
                                gegenwärtigen und zukünftigen
                                Vertragsverhältnisse mit der AGILA
                                Haustierversicherung AG.
                              </p>

                              <p class="tabs__text">
                                Hinweis: Ich kann innerhalb von acht Wochen,
                                beginnend mit dem Belastungsdatum, die
                                Erstattung des belasteten Betrages verlangen.
                                Es gelten dabei die mit meinem Kreditinstitut
                                vereinbarten Bedingungen.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div id="tab-2" v-bind:class="{'tabs__pane': true, 'active': !isLs}">
                          <div class="form__row">
                            <div class="form__group form--huge100">
                              <div class="input input__completed">
                                <div class="input__wrap">
                                  <input class="input__box nonselect" type="text" readonly name="recipient" id="recipient" placeholder="AGILA Haustierversicherung AG" value="AGILA Haustierversicherung AG" />
                                  <label for="recipient" class="input__label input__label--inner">
                                    Empfänger
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form__row">
                            <div class="form__group form--huge100">
                              <div class="input input__completed">
                                <div class="input__wrap">
                                  <input class="input__box nonselect" type="text" readonly name="recipient-bank" id="recipient-bank" placeholder="Commerzbank Hannover" value="Commerzbank Hannover" />
                                  <label for="recipient-bank" class="input__label input__label--inner">
                                    Bank des Empfängers
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form__row">
                            <div class="form__group form--huge100">
                              <div class="input input__completed">
                                <div class="input__wrap">
                                  <input class="input__box nonselect" type="text" readonly name="iban2" id="iban2" placeholder="DE58 2504 0066 0450 0393 00" value="DE58 2504 0066 0450 0393 00" />
                                  <label for="iban2" class="input__label input__label--inner">
                                    IBAN
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="tabs__note">
                            <p class="tabs__text">
                              Bitte überweisen Sie in Zukunft die {{ paymentIntervalName }}
                              Beitragszahlungen an die oben abgebildeten
                              Kontodaten.
                              Diese erhalten Sie noch einmal mit ihren Vertragsunterlagen per E-Mail.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-bind:class="{'form__section': true, 'hidden': leadin.risk_id != undefined }">
                <div class="form__title form_title_less">
                  <h2>Vertragsbeginn festlegen</h2>
                </div>
                <div class="form__row">

                    <div  v-bind:class="{'form__remark': true, 'remark': true, 'upper_remark': true, 'noclick': !startDateType, 'hidden': startDateType}">
                      <span class="remark__icon">
                        <i class="icon-exclamation-point"></i>
                      </span>
                      <p v-bind:class="{'remark__text': true}">
                        Bei dem von Ihnen gewünschten Angebot ist kein abweichender Vetragsbeginn möglich.
                      </p>
                    </div>
                    <div class="form__section">
                    <div v-bind:class="{'fieldset': true, 'noclick': !startDateType}">
                        <a-input label="Vertragsbeginn" v-model="startDate" :eclass="leadin.errorMessage.startdate" type="date"  yeartype="start" :rules="[rules.start]" v-on:input="pushDataLayer('zahlung', 'start_date', startDate)"/>
                    </div>
                    <!--<div v-bind:class="{'fieldset': true, 'hidden': startDateType}">
                        {{ startDateSimple }}
                    </div>-->
                  </div>
                  <div v-bind:class="{'form__remark': true, 'remark': true, 'hidden': !startDateType}">
                    <span class="remark__icon">
                      <i class="icon-exclamation-point"></i>
                    </span>
                    <p v-bind:class="{'remark__text': true}">
                      Vertragsbeginn am auf die Antragstellung folgenden Tag
                      oder zu einem von Ihnen ausgewählten späteren Termin.
                    </p>

                  </div>
                </div>
              </div>
            </div>
            <div class="form__links">
              <div class="container">
                <div class="form__btn">
                  <div class="form__btn-holder">
                      <a-btn primary dark @click="submitBottom" class="btn btn--green">Weiter</a-btn>
                  </div>
                  <a v-if="!leadin.contract_id" v-on:click="clickBack()" class="form__back-link back-link"><span class="back-link__icon icon-left-arrow"></span>Vorheriger Schritt</a>
                </div>
              </div>
            </div>
          </a-form>
        </section>
</template>
<!--
1. Nachkucken, dass special ist oder nicht
2. ist das Tier gesund
    (zeigt ihr Tier Symptome von A)
    chronish krank
    name der Krankheit
-->

<script>
import {entryChannel} from "@/vars";
import Crossselling from "./Crossselling.vue";

export default {
  components: {
    Crossselling,
  },
    model: {
        prop: 'leadin',
        event: 'leademit'
    },
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        leadin: {
            type: Object,
            default() {
                return {}
        }}
    },
    data: () => ({
        productInfo: '',
        productName: '',
        productPrice: '',
        paymentinterval: '1',
        productSet: '',
        productActive: '',
        paymentType: 'ls',
        paymentIntervalName: 'monatlichen',
        startDate: '',
        isLs: true,
        sepa: false,
        iban: '',
        startDateSimple: '',
        startDateType: true,
        openClose: false,
        cClass: {'cyearly': true, 'cmonthly': true},
        cinterval: {'12': 'cyearly', '1': 'cmonthly'},
        cross: [],
        combiP: {id:'', name:'', price:''},
        crossP: {id:'', name:'', price:''},
        possCross: {},
        addPriceCombi: 0,
        addPriceCross: 0,
        optimizely46: 0,
        tooltips: {
          combi: false
        },
        rules: {
            notEmptyText: function(v) {
                return (!v || null)? 'Darf nicht leer sein!': true;
            },
            checked: v => v || 'Bitte bestätigen Sie das SEPA-Mandat',
            /*start: function(v) {
              let startDate = new Date()
              startDate.setDate(startDate.getDate()+1)
              return (startDate - 36000000 > new Date(v))? 'Der Vertrag kann zu diesem Zeitpunkt noch nicht beginnen!': true;
            },*/
            start: function(v) {
              let startDate = new Date();
              startDate.setHours(0, 0, 0, 0)
              startDate.setDate(startDate.getDate()+1)
              let vin = new Date(v)
              vin.setHours(0, 0, 0, 0)
                return (startDate - 36000000 > vin)? 'Der Vertrag kann zu diesem Zeitpunkt noch nicht beginnen!': true;
            },
            correctIBAN: function(v) {return v?"Bitte geben Sie eine korrekte IBAN ein":"Bitte geben Sie eine correcte IBAN ein"},
        }
    }),
    watch: {
        leadin: {
            immediate: true,
            handler (to) {
                this.paymentinterval = (to.paymentinterval)?to.paymentinterval:'1'
                this.productActive = to.productActive
                this.startDate = to.startDate
                this.paymentType = to.paymentType
                this.isLs = to.isLs
                this.sepa = to.sepa
                this.iban = to.iban
                this.productInfo = to.productInfo
                this.productName = to.productName
                this.productPrice = to.productPrice
                this.calcAll ()
            }
        }
    },
    mounted: function (){
      if (window.optimizely46) {
        this.optimizely46 = window.optimizely46;
      }

      // set firstPaymentDate form payment interval and vertragsbegin
        /*this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate()+1)*/
        this.calcAll ();

      if (typeof this.registry.crossselling[this.leadin.productActive] !== 'undefined'
          && typeof this.registry.crossselling[this.leadin.productActive]['cross1'] !== 'undefined') {

        let cross = []
        cross = this.registry.crossselling[this.leadin.productActive]['cross1']
        var t1 = new Date(this.leadin.petbirthday);
        var t2 = new Date();
        var dif = ( t2.getTime() - t1.getTime() ) / 1000;
        let y = 0;

        for (let i = 0; i < cross.length; i++) {

          if ((cross[i].id == 11 || cross[i].id == 4) && dif > 157680000) {
            continue;
          }

          if ((cross[i].id == 12 || cross[i].id == 3 || cross[i].id == 1 || cross[i].id == 2) && dif > 252288000) {
            continue;
          }

          this.cross[y] = cross[i]
          y++;

        }

        if (typeof this.registry.crossselling[this.leadin.productActive]['combi'] !== 'undefined') {
          this.cross.push(this.registry.crossselling[this.leadin.productActive]['combi'][0])
        }
      }
    },
    computed: {
      /*
      breeds[this.leadin.breed] is undefined
    mounted Payment.vue:364
    VueJS 12
    */
        paymentRules () {
          const rules = []

          if (this.isLs === true) {
              rules.push(this.rules.notEmptyText)
          }

          if (this.isLs === true && this.isValidIBANNumber(this.iban) != 1) {
            rules.push(this.rules.correctIBAN)
          }

          return rules
        },
        startRule () {

          const rules = []

          let startDate = new Date()

          startDate.setDate(startDate.getDate()+1)
          if (startDate > new Date(this.startDate)) {
            rules.push(this.rules.toEarly)
          }

          return rules
        },
        sepaRule () {
          const rules = []

          if (this.isLs === true) {
              rules.push(this.rules.checked)
          }

          return rules
        },
        /*productPriceF () {
          return (parseFloat(this.leadin.productPrice.replace(/,/, '.')) * this.paymentinterval).toFixed(2)
        },*/
        interval() {
          return this.registry.paymentIntervals[this.paymentinterval];
        },
        productPriceCalc() {
          return (this.productPrice * this.paymentinterval).toFixed(2).replace(/\./, ',');
        }
    },
    methods: {
      crosssellingCheck (data) {
        let cross = data.cross;
        let price = data.productPrice;
        let name = data.productName;

        const checkboxes = document.querySelectorAll('[data-cross]')
        if(cross.combi == 1 ) {
          this.combiP.id = cross.id
          this.combiP.name = name
          this.addPriceCombi = this.combiP.price = price
        }
        else {
          this.productPrice = (parseFloat(this.leadin.productPrice) - cross.pdiscount).toFixed(2)
          this.crossP.id = cross.id
          this.crossP.name = name
          this.addPriceCross = this.crossP.price = price
        }

        for(let checkbox in checkboxes) {
          if(isNaN(checkbox) || typeof checkboxes[checkbox].dataset == undefined) {
            continue;
          }
          else if (checkboxes[checkbox].dataset.cross == 1) {
            if(!checkboxes[checkbox].checked) {
              this.combiP.id = ''
              this.addPriceCombi = 0
            }

            continue
          }

          if (checkboxes[checkbox].dataset.id == cross.id) {
            if(!checkboxes[checkbox].checked) {
              this.productPrice = this.leadin.productPrice
              this.crossP.id = ''
              this.addPriceCross = 0
            }

            continue
          }

          this.pushDataLayer('ecommerce', 'kombi_option', name, this.crossP.id);

          if (checkboxes[checkbox].dataset.cross !== 1 && cross.combi != 1) {
            checkboxes[checkbox].checked = false;
          }
        }

        this.leadin.crossselling = this.crossP.id
        this.productPrice = (parseFloat(this.addPriceCross) + parseFloat(this.addPriceCombi) + parseFloat(this.productPrice)).toFixed(2)


      },
      clickBack() {
        if (this.isHPS(this.leadin)) {
          this.$parent.back(1, 'persoenliche_daten');
          this.pushDataLayer('zahlung','go_back', 'persoenliche-daten')
        } else {
          this.$parent.back(2, 'gesundheit');
          this.pushDataLayer('zahlung','go_back', 'gesundheit')
        }
      },
     calcAll () {
      this.startDate = new Date(this.registry.date);

        let pi_allowed = this.registry.productByID[this.productActive].payment_interval_allowed

        let pia_list = ['12', '6', '3', '1'];

        if (pi_allowed != '') {
          pia_list = JSON.parse(pi_allowed);
          if (pia_list.length === 1) {
            this.paymentinterval = pia_list[0];
          }
        }

        for (var i = 0; i < pia_list.length; i++) {
          this.cClass[this.cinterval[pia_list[i]]] = false
        }

        if (this.registry.productByID[this.productActive].crossselling_group == 1) {
          this.startDateType = false;

          this.startDateSimple = this.startDate.getDate() + '.' + this.startDate.getMonth() + '.' + this.startDate.getFullYear()
        }

        let product = this.registry.productByID[this.productActive]

        const racee = ['', 'dog', 'cat']

        this.productInfo = this.registry.productMatrix[racee[this.leadin.race]][product.abbreviation].data.text

        this.productName = product.title
        let matrix = this.getMatrix(this.leadin, this.registry, this.productActive);

        let seconds = this.calcAgeInSeconds(this.leadin.petbirthday)

        this.productPrice = parseFloat(this.calcPrice(matrix, seconds).toString().replace(/,/, '.'))

        if(this.leadin.race == 1 && (this.leadin.hashR !== undefined && this.leadin.hashR == true)){
            if(this.registry.crossselling[this.leadin.cross] != undefined && this.registry.crossselling[this.leadin.cross]['cross1'] != undefined) {
                for(let i = 0; i < this.registry.crossselling[this.leadin.cross]['cross1'].length; i++) {
                    if(this.registry.crossselling[this.leadin.cross]['cross1'][i]['id'] == this.productActive) {
                        let priceRed = (this.registry.crossselling[this.leadin.cross]['cross1'][i]['cdiscount'] / 12).toFixed(2)
                        this.productPrice = Number(this.productPrice) - priceRed
                        break;
                    }
                }
            }
        }
        this.productPrice = this.productPrice.toFixed(2)
     },
       submitBottom() {
          if (this.$refs.paymentForm.validate()) {
              this.leadin.paymentinterval = this.paymentinterval
              this.leadin.paymentType = this.paymentType
              this.leadin.iban = this.iban
              this.leadin.sepa = this.sepa
              this.leadin.isLs = this.isLs
              this.leadin.productInfo = this.productInfo
              this.leadin.productName = this.productName
              this.leadin.productPrice = this.productPrice
              let d = new Date(this.startDate)

              this.leadin.startDate = d.toISOString().split('T')[0]

              // Tracking Start
            if (
                this.registry.cc &&
                (this.registry.cc.includes("gat") ||
                    this.registry.cc.includes("all") ||
                    this.registry.cc.includes("marketing"))
            ) {
              try {
                let symptoms_list = [];
                if (this.leadin.symptomElements && this.leadin.symptomElements.length) {
                  this.leadin.symptomElements.forEach(symptom => {
                    symptoms_list.push({
                      id: symptom.id,
                      name: symptom.name,
                    })
                  })
                }
                let treatment_list = [];
                if (this.leadin.treatmentBase) {
                  this.leadin.healthElements.forEach(treatment => {
                    treatment_list.push({
                      id: treatment.preCondition.id,
                      name: treatment.preCondition.name,
                      category: treatment.conditionCategory.name,
                      description: treatment.description,
                      status: treatment.status,
                      occurrence: treatment.occurrence
                    })
                  })
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null})
                window.dataLayer.push({
                  event: "add_payment_info",
                  ecommerce: {
                    details: {
                      currency: "EUR",
                      value: this.leadin.productPrice,
                      antragsstrecke_ueber: entryChannel,
                      customer: {
                        city: this.leadin.city,
                        country: this.leadin.country,
                        mail: this.leadin.email,
                        telefon: this.leadin.phone
                      },
                      payment: {
                        payment_type: this.paymentType,
                        payment_intervall: this.paymentinterval,
                        start_date: this.leadin.startDate,
                        product_name: this.productName,
                      },
                      pet: {
                        rasse: this.leadin.breed,
                        alter: this.calculateAge(this.leadin.petbirthday),
                        geschlecht: this.leadin.petgender,
                        tierart: this.leadin.race == '1' ? "Hund" : "Katze",
                        symptoms_list: symptoms_list,
                        treatment: this.leadin.treatmentBase ? "ja" : "nein",
                        treatment_list: treatment_list,
                      }
                    },
                    items: this.getTrackingProductItems()
                  }
                });
              } catch (e) {
                console.error(e);
              }
            }
            // Tracking End

            this.$emit('leademit', this.leadin)
            this.$parent.advance('advancePayment', true)
            return true;

          }else {
              document.getElementById('jumppoint').scrollIntoView();
          }
        },
        setPaymentType(pt) {
            this.isLs = true
            this.paymentType = pt

            if (pt === 'ue') {
                this.isLs = false
            }
        },
        firstPaymentDate () {
          let date = new Date(this.startDate);
          date.setDate(date.getDate() + 15);
          let day = date.getDate()


          if (day >= 1 && day < 15) {
            return '15.' + ('0' + (date.getMonth()+1)).slice(-2) + '.' + date.getFullYear()
          }

          let date2 = new Date()
          if (date.getMonth() == 11) {
              date2 = new Date(date.getFullYear() + 1, 0, 1);
          } else {
              date2 = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          }


          return '01.' + ('0' + (date2.getMonth()+1)).slice(-2) + '.' + date2.getFullYear()

          /*
          this. = 0
          this.startDate
          startDate + 15 Tage
          get month, get day
          check if day > 15 oder kleiner 15
          danach entweder monat +1 und 1. oder Datum auf 15
          */
        },
        isValidIBANNumber(input) {
          var CODE_LENGTHS = {
              AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
              CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
              FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
              HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
              LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
              MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
              RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
              AL: 28, BY: 28, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
              SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
          };
          var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                  code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                  digits;
          // check syntax and length
          if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
              return false;
          }
          // rearrange country code and check digits, and convert chars to ints
          digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
              return letter.charCodeAt(0) - 55;
          });
          // final check
          return this.mod97(digits);
      },
      mod97(string) {
          var checksum = string.slice(0, 2), fragment;
          for (var offset = 2; offset < string.length; offset += 7) {
              fragment = String(checksum) + string.substring(offset, offset + 7);
              checksum = parseInt(fragment, 10) % 97;
          }
          return checksum;
      }

    }
}
</script>
<style scoped>
.crossselling {
  background-color: #f6faff;
  padding: 16px;
}
.short-radio .checkbox.control.type-radio {
  padding:18px;
}
.checkbox.control.type-radio .label{
  padding-left:4px important;
  margin:10px;
}
.short-radio .form__group {
    padding:0 2px
}
.form__row.checkbox {
    margin-left: 2px;
    margin-bottom: 25px;
}
.noclick {
  pointer-events: none;
}
.upper_remark {
  margin-top:15px;
  margin-bottom: -10px;
}
</style>
<style>
.noclick .glyph {
  color:darkgrey !important;
}

@media (max-width: 796px) {
  .checkbox.narrow-text .text {
      max-width:350px;
  }
}
.card--small.max--width {
        max-width:100%;
        padding:15px;
    }
    .container__inner {
        max-width:100%;
    }
.open-close__opener .icon-down-arrow {
  font-size: 6px;
  margin-left: 9px;
}
.content-wrap--summary .card--small .card__header {
  padding-top: 20px;
}
.nonselect{
  cursor: default;
}
</style>
